export default {
  dark: {
    background: 'transparent',
    color: 'rgba(255,255,255,1)',
    fontWeight: 300,
  },
  borderDark: {
    borderColor: 'rgba(255,255,255,1)',
  },
  caretDark: {
    color: '#fff',
  },
  iconDark: {
    color: '#fff',
    fontSize: '0.86rem',
  },
  dropdown: {
    position: 'relative',
  },
  menuVisible: {
    position: 'fixed',
  },
}
